import React, { useEffect, useState } from 'react';
import Alert from 'react-bootstrap/Alert';

function ModalAlert({settings, setSettings}) {

    const [isError, setIsError] = useState(false);
    const [message, setMessage] = useState("");
    const [show, setShow] = useState(false);

    useEffect( () => {
        if (settings.show == false) {
          setIsError(false);
          setMessage("");
        }
        else{
          setIsError(settings.isError);
          setMessage(settings.message);
        }
        setShow(settings.show);

    }, [settings]);

  const variant = isError ? 'danger' : 'success';

  const errorMessage = message ? message : 'Something went wrong, please try again.';

  const headerMessage = isError ? '' : 'Success';

  function toggleShow() {
    setSettings( (old) => ({...old, show:false, isError:false, message:""}) );
  }

  if (show) {
    return (
      <Alert variant={variant} onClose={() => toggleShow() } dismissible>
        <Alert.Heading>{headerMessage}</Alert.Heading>
        <p dangerouslySetInnerHTML={{__html: errorMessage}}></p>
      </Alert>
    );
  }
  else{
    return <></>;
  }
}
export default ModalAlert;